import { ComponentProps, ReactElement } from "react";
import { Link, useLocation } from "react-router";
import { createParentNavigationState } from "../../hooks/useParentNavigation";
import { useDashboardContext } from "../dashboard/Dashboard.shared";

type ParentLinkProps = Omit<ComponentProps<typeof Link>, "replace">;

export const ParentLink = ({
  state,
  ...props
}: ParentLinkProps): ReactElement => {
  const location = useLocation();
  const { isTwoPanel } = useDashboardContext();

  return (
    <Link
      {...props}
      replace={false}
      state={isTwoPanel ? state : createParentNavigationState(location, state)}
    />
  );
};
